import { render, staticRenderFns } from "./supplier-summary-table.vue?vue&type=template&id=5847dcbc&scoped=true"
import script from "./supplier-summary-table.vue?vue&type=script&lang=js"
export * from "./supplier-summary-table.vue?vue&type=script&lang=js"
import style0 from "./supplier-summary-table.vue?vue&type=style&index=0&id=5847dcbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847dcbc",
  null
  
)

export default component.exports